import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { PaginatedParams, Response } from 'services/api/types'
import { OrdersCredit } from '../types'

type OrderClientCredit = PaginatedParams & {
  customerId: string
}

const loadOrderClientCredit = (
  data: OrderClientCredit
): Response<OrdersCredit> => {
  const { page = 1, limit = 10 } = data
  return axios.get(`/orders/customers/${data.customerId}/credit`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderClientCredit(query: OrderClientCredit) {
  return useQuery(
    ['orderClientCredit', query],
    () => loadOrderClientCredit(query),
    {
      enabled: !!query.customerId,
      onError: () =>
        toast.error('Não foi possível carregar créditos!', {
          toastId: 'loadOrderCredit'
        })
    }
  )
}
